import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  backButton: css`
    inset-block-start: ${spacing(2)};
    inset-inline-start: ${spacing(2)};
    position: fixed;
  `,
  addressPin: css`
    font-size: ${spacing(7)};
    inset-block-start: ${spacing(-6)};
    inset-inline-start: ${spacing(-3.5)};
    position: relative;
  `,
}
